import {
  string,
  object,
  ObjectSchema,
  TypedForm,
  date,
  array,
} from 'libs/form';
import { localFileScheme } from 'modules/client/common/helpers';
import { LocalFileEntity } from 'modules/client/common/types';
import { Maybe } from 'types/maybe';

export interface OpenAccountOrderFormType_Finance {
  openAccountOrder_Finance: {
    number?: Maybe<string>;
    date?: Maybe<Date>;
    orderReceivedDate?: Maybe<Date>;
    document?: Maybe<LocalFileEntity[]>;
  };
}

export const openAccountOrderSchema_Finance: ObjectSchema<OpenAccountOrderFormType_Finance> =
  object({
    openAccountOrder_Finance: object({
      number: string().nullable().max(200),
      date: date().nullable(),
      orderReceivedDate: date().nullable(),
      document: array().of(localFileScheme.required()).optional().max(1),
    }),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<OpenAccountOrderFormType_Finance>();
